// client/src/modals/TokenExpiredModal.jsx
import React from "react";
import { FaTimes, FaBan } from "react-icons/fa";

/**
 * TokenExpiredModal - Warns the user before posting that one or more
 * selected platforms have an expired authorization token, and offers to
 * take them to the Integrations page to reconnect.
 *
 * @param {boolean} isOpen - Controls modal visibility
 * @param {function} onClose - Callback to dismiss without navigating
 * @param {function} onReconnect - Callback to navigate to the Integrations page
 * @param {string[]} platforms - Labels of the expired platforms (already formatted)
 */
const TokenExpiredModal = ({ isOpen, onClose, onReconnect, platforms = [] }) => {
  if (!isOpen) return null;

  const names = platforms.join(", ");

  return (
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        className="modal-content modal-light"
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          maxWidth: "480px",
          width: "100%",
          padding: "24px",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                backgroundColor: "#fee",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#c00",
              }}
            >
              <FaBan size={22} />
            </div>
            <h2
              style={{
                margin: 0,
                fontSize: "20px",
                fontWeight: "600",
                color: "#1a1a1a",
              }}
            >
              Authorization Expired
            </h2>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#666",
              fontSize: "20px",
            }}
            aria-label="Close modal"
          >
            <FaTimes />
          </button>
        </div>

        {/* Body */}
        <div style={{ marginBottom: "24px" }}>
          <p
            style={{
              margin: "0 0 12px 0",
              fontSize: "16px",
              lineHeight: "1.5",
              color: "#333",
            }}
          >
            Your authorization for <strong>{names}</strong> has expired.
          </p>
          <p
            style={{
              margin: "0",
              fontSize: "14px",
              lineHeight: "1.5",
              color: "#666",
            }}
          >
            Reconnect this integration before posting to it again.
          </p>
        </div>

        {/* Footer Buttons */}
        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onClose}
            className="btn btn-outline"
            style={{
              padding: "10px 20px",
              fontSize: "14px",
              fontWeight: "500",
              borderRadius: "6px",
              border: "1px solid #ddd",
              backgroundColor: "#fff",
              color: "#333",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f5f5f5";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#fff";
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => {
              onReconnect();
              onClose();
            }}
            className="btn btn-danger"
            style={{
              padding: "10px 20px",
              fontSize: "14px",
              fontWeight: "500",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#dc2626",
              color: "#fff",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#b91c1c";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#dc2626";
            }}
          >
            <FaBan size={14} />
            Reconnect
          </button>
        </div>
      </div>
    </div>
  );
};

export default TokenExpiredModal;
